module.exports = __webpack_public_path__ + "img/DRC.67a89af0.png";